export default __webpack_public_path__ + "media/Number3.924eb883937566074e37286f2d121a03.mp4";